import { useState } from "react";
import { FaServer } from "react-icons/fa";
import { resolveSystemIconUrl } from "./systemIconCandidates";

function SystemIcon({ system, iconUrl, size = 24, className = "" }) {
  const [broken, setBroken] = useState(false);

  if (!system) return null;

  const effectiveIconUrl = resolveSystemIconUrl(system, iconUrl);
  const useImageIcon = !!effectiveIconUrl && !broken;

  return useImageIcon ? (
    <img
      src={effectiveIconUrl}
      alt=""
      className={className}
      style={{ width: size, height: size, objectFit: "contain" }}
      onError={() => setBroken(true)}
    />
  ) : (
    <FaServer size={size} className={className} />
  );
}

export default SystemIcon;
